"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedInvoicePayerResponse = exports.mockedInvoicePayerCreatOrUpdate = void 0;
const country_1 = require("../country");
exports.mockedInvoicePayerCreatOrUpdate = {
  firstName: 'payer first name',
  lastName: 'payer last name',
  email: 'payer@email.com',
  country: country_1.mockedCountryResponse.id,
  city: 'Moscow',
  address: 'Address #1',
  postalCode: '720010'
};
exports.mockedInvoicePayerResponse = {
  firstName: 'payer first name',
  lastName: 'payer last name',
  email: 'payer@email.com',
  country: country_1.mockedCountryResponse,
  city: 'Moscow',
  address: 'Address #1',
  postalCode: '720010',
  id: 1,
  isDeleted: false
};